import { useTranslation } from 'react-i18next';
import { Theme } from '@routific/hive';
import Checkbox from '../../../shared/Checkbox';

interface Props {
  onConfirm: (state: boolean) => void
}
const ConfirmDisableUnschedule: React.FC<Props> = ({ onConfirm }) => {
  const { t } = useTranslation('components');

  return (
    <Checkbox
      onChange={onConfirm}
      label={t('common:disableShowAgain')}
      sx={{ marginTop: Theme.Spacing.mdSpacing }}
    />
  );
};

export default ConfirmDisableUnschedule;
